export const resumeUrlKey = (userId) => `practiceSmartResumeUrl:${userId}`;

export function quizQuestionUrl(quizId, index, { mode = "study", applyMode = false } = {}) {
  if (!quizId || !index) return null;
  const params = new URLSearchParams();
  if (mode) params.set("mode", mode);
  params.set("quiz_id", quizId);
  if (applyMode) params.set("apply_mode", "1");
  return `/quiz_item_responses/${index}?${params.toString()}`;
}

export function welcomeOfflineStartUrl(quizId, firstIndex, mode) {
  if (!mode) return null;
  return quizQuestionUrl(quizId, firstIndex, { mode, applyMode: true });
}

export function stripWelcomeApplyModeFromUrl() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("apply_mode")) return;

  url.searchParams.delete("apply_mode");
  const query = url.searchParams.toString();
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${query ? `?${query}` : ""}${url.hash}`,
  );
}

export async function cacheQuizUrl(url) {
  if (!url) return;
  if (!("caches" in window)) return;
  if (!navigator.serviceWorker?.controller) return;
  try {
    const absoluteUrl = new URL(url, window.location.origin).href;
    await fetch(absoluteUrl, { credentials: "include" });
  } catch (error) {
    console.warn("[QuizOffline] cacheQuizUrl failed", url, error);
  }
}

const isSameQuizPage = (cachedUrl, wantedUrl) =>
  cachedUrl.pathname === wantedUrl.pathname &&
  cachedUrl.searchParams.get("quiz_id") === wantedUrl.searchParams.get("quiz_id") &&
  cachedUrl.searchParams.get("mode") === wantedUrl.searchParams.get("mode");

async function hasSameQuizPage(wantedUrl) {
  for (const name of await caches.keys()) {
    const requests = await (await caches.open(name)).keys(wantedUrl.href, { ignoreSearch: true, ignoreVary: true });
    if (requests.some((request) => isSameQuizPage(new URL(request.url), wantedUrl))) return true;
  }
  return false;
}

export async function isQuizUrlCached(url) {
  if (!url) return false;
  if (!("caches" in window)) return false;
  const wantedUrl = new URL(url, window.location.origin);
  try {
    return Boolean(await caches.match(wantedUrl.href, { ignoreVary: true })) || (await hasSameQuizPage(wantedUrl));
  } catch {
    return false;
  }
}
